import { mdiDesktopClassic } from '@mdi/js'

export default {
  title: 'CBT',
  to: 'cbt-school',
  icon: mdiDesktopClassic,
  resource: 'CbtSchool',
  action: 'read',
}
